import { render, staticRenderFns } from "./SentimentModelExport.vue?vue&type=template&id=0949454b&"
import script from "./SentimentModelExport.vue?vue&type=script&lang=js&"
export * from "./SentimentModelExport.vue?vue&type=script&lang=js&"
import style0 from "./SentimentModelExport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports